module.exports = __webpack_public_path__ + "static/01_onboarding.fa157112.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/images/project6/01_onboarding.jpg
// module id = 510
// module chunks = 111663361672460